import { createSelector } from 'reselect';

import createCartItemFromPurchase from '../utils/ordering/createCartItemFromPurchase';

import getStagedPurchases from './getStagedPurchases';
import getRootCategory from './getRootCategory';
import { getChoiceOrderingMethod, getBrands } from './config';
import getItems from './getItems';

export default createSelector(
  [
    getStagedPurchases,
    getChoiceOrderingMethod,
    getBrands,
    getRootCategory,
    getItems,
  ],
  (
    enhancedStagedPurchases,
    choiceOrderingMethod,
    brands,
    rootCategory,
    items,
  ) => {
    if (choiceOrderingMethod === null) {
      return [];
    }

    return (enhancedStagedPurchases || []).map(p => ({
      mimCategoryId: p.mimCategoryId,
      ...createCartItemFromPurchase(
        p,
        choiceOrderingMethod,
        brands,
        rootCategory,
        items,
      ),
    }));
  },
);
